import { environment } from 'src/environments/environment';

/** root url */
export const AppURL = {
  account: 'Account',
  home: 'Home',
  mangeForm: 'MangeForm',
  response: 'Response',
  formSurvey: 'FormSurvey',
  form: 'form',
  abExperiment: 'AbExperiment',
  userGuide: 'UserGuide',
};

export function getPublishBaseURL(): string {
  const isLocalhost = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const base = isLocalhost ? window.location.origin : environment.surveyboxProURL;
  return base.endsWith('/') ? base : `${base}/`;
}

/** ต่อ publish_link (จาก backend) + publish_key ให้เป็น URL เต็มที่ใช้งานได้จริง
 *  publish_link ที่บันทึกใหม่จะเป็น path สัมพัทธ์ล้วน (เช่น "form?key_id=") ไม่มี host ฝังอยู่ — ต่อ host ปัจจุบันจาก environment ให้ตอนแสดงผลเสมอ
 *  จึงไม่มีปัญหาลิงก์เก่าค้าง host เดิมตลอดไปเวลาเปลี่ยน environment/deploy โดเมนใหม่
 *  ยังรองรับ record เก่าที่เคยบันทึก publish_link แบบเต็ม (http://.../form?key_id=) อยู่แล้ว — เช็คก่อนว่ามี host ฝังมาหรือยัง ถ้ามีก็ใช้ตามเดิม ไม่ต่อซ้ำ */
export function buildPublishURL(publishLink: string | null | undefined, publishKey: string | null | undefined): string {
  const link = publishLink || '';
  const key = publishKey || '';
  if (link.startsWith('http://') || link.startsWith('https://')) return `${link}${key}`;
  return `${getPublishBaseURL()}${link}${key}`;
}

export function getUploadsBaseURL(): string {
  return environment.imgURL || '';
}

